import { z } from "zod";

export const IngredientLineSchema = z.object({
    "@id": z.string(),
    id: z.number(),
    name: z.string(),
});

export const SelectorIngredientSchema = z.object({
    "@id": z.string(),
    id: z.number(),
    name: z.string(),
    clientId: z.string().optional(),
    ingredientLine: IngredientLineSchema.optional(),
    organic: z.boolean().optional(),
    ingredientReferenceId: z.number().optional(),
    domains: z
        .array(
            z.object({
                "@id": z.string(),
                name: z.string(),
            }),
        )
        .optional(),
});

export type SelectorIngredient = z.infer<typeof SelectorIngredientSchema>;
export type IngredientLine = z.infer<typeof IngredientLineSchema>;
